import React, { FC } from 'react';
import { Result } from 'antd';

const NotFound: FC<{}> = () => (
  <Result status="warning" title="There are some problems with your operation." />
);

export default NotFound;
